/* GIS ERGON: surface reviews that include photos first in the Air Reviews list.
   Marks photo cards with a data attribute; CSS `order` does the reordering so the widget's own re-renders don't undo it. */
(function () {
  const CARD = '.AirReviews-Blocks__ReviewDetails';
  const hasPhoto = (card) => !!card.querySelector('.AirReviews-Blocks__Images img, .AirReviews-Blocks__Images video');
  let ticking = false;
  function mark() {
    document.querySelectorAll(CARD).forEach((card) => {
      const yes = hasPhoto(card);
      if (yes && !card.hasAttribute('data-ge-photo')) card.setAttribute('data-ge-photo', '1');
      if (!yes && card.hasAttribute('data-ge-photo')) card.removeAttribute('data-ge-photo');
    });
  }
  new MutationObserver(() => {
    if (ticking) return;
    ticking = true;
    setTimeout(() => { ticking = false; mark(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
  setInterval(mark, 1500);
})();
